import React, { useCallback, useState } from 'react';
import menuStyles from './styles';

type Props = {
  title: string;
  items: JSX.Element[];
}; 

const Menu = (props: Props) => {
  const classes = menuStyles();

  const {
    title,
    items,
  } = props;

  const [open, setOpen] = useState<boolean>(false);

  const mouseEnter = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setOpen(true);
  }, []);

  const mouseLeave = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setOpen(false);
  }, []);

  // Add items with open setting of this menu
  // We do this so we can always draw the item no matter our open state
  // This way hotkeys are always available.
  let index: number = 0;
  const itemClones: JSX.Element[] = items.map(item => React.cloneElement(item, {
    ...item.props, 
    open: open,
    key: index++,
  }))

  return (
    <div 
      className={classes.menu} 
      onMouseEnter={mouseEnter} 
      onMouseLeave={mouseLeave}
    >
      { title }
      {
        <div className={classes.menuItemContainer}>
          {
            itemClones
          }
        </div>
      }
    </div>
  );
};

export default Menu;